import { Route, Routes, useLocation } from "react-router";
import { SiteShell } from "../components/SiteShell";
import { privacyDocuments } from "../content/privacy";
import { termsDocuments } from "../content/terms";
import { HomePage } from "../pages/HomePage";
import { LegalPage } from "../pages/LegalPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { PlayPage } from "../pages/PlayPage";
import { SupportPage } from "../pages/SupportPage";
import type { Language } from "../config/site";

function Page({ language, children }: { language: Language; children: React.ReactNode }) {
  return <SiteShell language={language}>{children}</SiteShell>;
}

function NotFoundRoute() {
  const { pathname } = useLocation();
  const language: Language = pathname.startsWith("/tr") ? "tr" : "en";
  return <Page language={language}><NotFoundPage language={language} /></Page>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Page language="en"><HomePage language="en" /></Page>} />
      <Route path="/privacy/" element={<Page language="en"><LegalPage document={privacyDocuments.en} /></Page>} />
      <Route path="/terms/" element={<Page language="en"><LegalPage document={termsDocuments.en} /></Page>} />
      <Route path="/support/" element={<Page language="en"><SupportPage language="en" /></Page>} />
      <Route path="/play/" element={<Page language="en"><PlayPage language="en" /></Page>} />

      <Route path="/tr/" element={<Page language="tr"><HomePage language="tr" /></Page>} />
      <Route path="/tr/privacy/" element={<Page language="tr"><LegalPage document={privacyDocuments.tr} /></Page>} />
      <Route path="/tr/terms/" element={<Page language="tr"><LegalPage document={termsDocuments.tr} /></Page>} />
      <Route path="/tr/support/" element={<Page language="tr"><SupportPage language="tr" /></Page>} />
      <Route path="/tr/play/" element={<Page language="tr"><PlayPage language="tr" /></Page>} />
      <Route path="*" element={<NotFoundRoute />} />
    </Routes>
  );
}
